(function () {
    if (window.vgrValidationSummaryFieldNavigationInitialized) {
        return;
    }

    window.vgrValidationSummaryFieldNavigationInitialized = true;

    document.addEventListener("click", function (event) {
        var target = event.target;

        if (!(target instanceof HTMLElement)) {
            return;
        }

        var link = target.closest("[data-validation-summary-field]");

        if (!(link instanceof HTMLAnchorElement)) {
            return;
        }

        var fieldKey = link.getAttribute("data-validation-summary-field");

        if (!fieldKey) {
            return;
        }

        var normalizedFieldKey = fieldKey.toLowerCase();
        var fields = document.querySelectorAll("input, select, textarea");
        var field = Array.from(fields).find(function (element) {
            return (element.id && element.id.toLowerCase() === normalizedFieldKey) ||
                (element.getAttribute("name") && element.getAttribute("name").toLowerCase() === normalizedFieldKey);
        });

        if (!field) {
            return;
        }

        event.preventDefault();

        field.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });

        window.setTimeout(function () {
            if (field instanceof HTMLElement) {
                field.focus();
            }
        }, 200);
    });
})();
